import { SelectAsyncInput } from '@core/components/Select';
import cnaeApi from 'app/services/api/servicoFiscal/cnaeApi';
import React from 'react';

const SelectCnae = ({ id, name, label, value, touched, error, onBlur, onChange }) => {
  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={value}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option?.codigo && option?.descricao ? `${option.codigo} - ${option.descricao}` : '';
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await cnaeApi.pesquisarCnaesPorSubclasse({
          size: 100,
          sort: 'codigo',
          page: next,
          q: query,
        });

        //const links = parseHeaderForLinks(response.headers.link);
        //const totalItems = response.headers['x-total-count'];
        const data = response?.data || [];

        return { data };
      }}
      fetchOnFocus
    />
  );
};

export default SelectCnae;
